import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useCardexList = () => {
  const [loading, setLoading] = useState(false);
  const [cardexList, setCardexList] = useState({});
  const [pageRef, setpageRef] = useState('');

  const { enqueueSnackbar } = useSnackbar();

  const getCardexList = (params = {}) => {
    setLoading(true);

    axiosClient
      .get(
        `Inventory/StockCard/Details?GuidBranch=${params?.branchGuid}&GuidZone=${params?.zoneGuid}`,
        { params },
      )
      .then(res => {
        if (res.status === 200) {
          setpageRef(res.data.value);
          if (res.data.value.items && res.data.value.items.length > 0) {
            setCardexList(prev => {
              const orderedList = res.data.value.items.map(element => ({
                id: element.guid,
                title: element.display,
                type: element.type,
                agent: element.agent,
                inbund: element.inbund,
                outbund: element.outbund,
                remained: element.remained,
                hasProblem: element.hasProblem,
                createTime: element.createTime,
                modifyTime: element.modifyTime,
                //   hasGraph: element.hasGraph,
                //   imageKey: element.imageKey,
                //   imageURL: element.imageURL,
              }));

              return { ...prev, [params?.page || 1]: orderedList };
            });
          }
          enqueueSnackbar('کاردکس یافت نشد.', { variant: 'info' });
        } else {
          enqueueSnackbar(res.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [getCardexList, loading, cardexList, pageRef];
};

export default useCardexList;
